var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/.pnpm/eventemitter3@4.0.7/node_modules/eventemitter3/index.js
var require_eventemitter3 = __commonJS({
  "../../node_modules/.pnpm/eventemitter3@4.0.7/node_modules/eventemitter3/index.js"(exports, module) {
    "use strict";
    var has = Object.prototype.hasOwnProperty;
    var prefix = "~";
    function Events() {
    }
    if (Object.create) {
      Events.prototype = /* @__PURE__ */ Object.create(null);
      if (!new Events().__proto__)
        prefix = false;
    }
    function EE(fn, context, once) {
      this.fn = fn;
      this.context = context;
      this.once = once || false;
    }
    function addListener(emitter, event, fn, context, once) {
      if (typeof fn !== "function") {
        throw new TypeError("The listener must be a function");
      }
      var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
      if (!emitter._events[evt])
        emitter._events[evt] = listener, emitter._eventsCount++;
      else if (!emitter._events[evt].fn)
        emitter._events[evt].push(listener);
      else
        emitter._events[evt] = [emitter._events[evt], listener];
      return emitter;
    }
    function clearEvent(emitter, evt) {
      if (--emitter._eventsCount === 0)
        emitter._events = new Events();
      else
        delete emitter._events[evt];
    }
    function EventEmitter2() {
      this._events = new Events();
      this._eventsCount = 0;
    }
    EventEmitter2.prototype.eventNames = function eventNames() {
      var names = [], events2, name;
      if (this._eventsCount === 0)
        return names;
      for (name in events2 = this._events) {
        if (has.call(events2, name))
          names.push(prefix ? name.slice(1) : name);
      }
      if (Object.getOwnPropertySymbols) {
        return names.concat(Object.getOwnPropertySymbols(events2));
      }
      return names;
    };
    EventEmitter2.prototype.listeners = function listeners(event) {
      var evt = prefix ? prefix + event : event, handlers = this._events[evt];
      if (!handlers)
        return [];
      if (handlers.fn)
        return [handlers.fn];
      for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
        ee[i] = handlers[i].fn;
      }
      return ee;
    };
    EventEmitter2.prototype.listenerCount = function listenerCount(event) {
      var evt = prefix ? prefix + event : event, listeners = this._events[evt];
      if (!listeners)
        return 0;
      if (listeners.fn)
        return 1;
      return listeners.length;
    };
    EventEmitter2.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
      var evt = prefix ? prefix + event : event;
      if (!this._events[evt])
        return false;
      var listeners = this._events[evt], len = arguments.length, args, i;
      if (listeners.fn) {
        if (listeners.once)
          this.removeListener(event, listeners.fn, void 0, true);
        switch (len) {
          case 1:
            return listeners.fn.call(listeners.context), true;
          case 2:
            return listeners.fn.call(listeners.context, a1), true;
          case 3:
            return listeners.fn.call(listeners.context, a1, a2), true;
          case 4:
            return listeners.fn.call(listeners.context, a1, a2, a3), true;
          case 5:
            return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
          case 6:
            return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for (i = 1, args = new Array(len - 1); i < len; i++) {
          args[i - 1] = arguments[i];
        }
        listeners.fn.apply(listeners.context, args);
      } else {
        var length = listeners.length, j;
        for (i = 0; i < length; i++) {
          if (listeners[i].once)
            this.removeListener(event, listeners[i].fn, void 0, true);
          switch (len) {
            case 1:
              listeners[i].fn.call(listeners[i].context);
              break;
            case 2:
              listeners[i].fn.call(listeners[i].context, a1);
              break;
            case 3:
              listeners[i].fn.call(listeners[i].context, a1, a2);
              break;
            case 4:
              listeners[i].fn.call(listeners[i].context, a1, a2, a3);
              break;
            default:
              if (!args)
                for (j = 1, args = new Array(len - 1); j < len; j++) {
                  args[j - 1] = arguments[j];
                }
              listeners[i].fn.apply(listeners[i].context, args);
          }
        }
      }
      return true;
    };
    EventEmitter2.prototype.on = function on(event, fn, context) {
      return addListener(this, event, fn, context, false);
    };
    EventEmitter2.prototype.once = function once(event, fn, context) {
      return addListener(this, event, fn, context, true);
    };
    EventEmitter2.prototype.removeListener = function removeListener(event, fn, context, once) {
      var evt = prefix ? prefix + event : event;
      if (!this._events[evt])
        return this;
      if (!fn) {
        clearEvent(this, evt);
        return this;
      }
      var listeners = this._events[evt];
      if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
          clearEvent(this, evt);
        }
      } else {
        for (var i = 0, events2 = [], length = listeners.length; i < length; i++) {
          if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
            events2.push(listeners[i]);
          }
        }
        if (events2.length)
          this._events[evt] = events2.length === 1 ? events2[0] : events2;
        else
          clearEvent(this, evt);
      }
      return this;
    };
    EventEmitter2.prototype.removeAllListeners = function removeAllListeners(event) {
      var evt;
      if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt])
          clearEvent(this, evt);
      } else {
        this._events = new Events();
        this._eventsCount = 0;
      }
      return this;
    };
    EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
    EventEmitter2.prototype.addListener = EventEmitter2.prototype.on;
    EventEmitter2.prefixed = prefix;
    EventEmitter2.EventEmitter = EventEmitter2;
    if ("undefined" !== typeof module) {
      module.exports = EventEmitter2;
    }
  }
});

// ../../node_modules/.pnpm/@podium+browser@1.2.1/node_modules/@podium/browser/src/MessageBus.js
var import_eventemitter3 = __toESM(require_eventemitter3(), 1);

// ../../node_modules/.pnpm/@podium+browser@1.2.1/node_modules/@podium/browser/src/utils.js
function toKey(channel, topic) {
  return `${channel}:${topic}`;
}

// ../../node_modules/.pnpm/@podium+browser@1.2.1/node_modules/@podium/browser/src/Event.js
var Event = class {
  constructor(channel, topic, payload) {
    this.channel = channel;
    this.topic = topic;
    this.payload = payload;
  }
  toKey() {
    return toKey(this.channel, this.topic);
  }
};

// ../../node_modules/.pnpm/@podium+browser@1.2.1/node_modules/@podium/browser/src/Queue.js
var Queue = class {
  constructor(maxLength = 10) {
    this.maxSize = maxLength;
    this.array = [];
  }
  push(item) {
    if (this.array.length >= this.maxSize) {
      this.array.pop();
    }
    this.array.unshift(item);
  }
  peek() {
    return this.array[0];
  }
  toArray() {
    return this.array.slice();
  }
};

// ../../node_modules/.pnpm/@podium+browser@1.2.1/node_modules/@podium/browser/src/Sink.js
var Sink = class {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  getQueue(channel, topic) {
    return this.map.get(toKey(channel, topic)) || new Queue();
  }
  push(event) {
    const queue = this.getQueue(event.channel, event.topic);
    queue.push(event);
    this.map.set(event.toKey(), queue);
  }
  peek(channel, topic) {
    return this.getQueue(channel, topic).peek();
  }
  log(channel, topic) {
    return this.getQueue(channel, topic).toArray();
  }
};

// ../../node_modules/.pnpm/@podium+browser@1.2.1/node_modules/@podium/browser/src/MessageBus.js
function getGlobalThis() {
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw new Error("unable to locate global object");
}
function getGlobalObjects() {
  let objs = getGlobalThis()["@podium"];
  if (!objs) {
    objs = {};
    objs.ee = new import_eventemitter3.default();
    objs.sink = new Sink();
    getGlobalThis()["@podium"] = objs;
  }
  return objs;
}
var MessageBus = class {
  constructor() {
    const { ee, sink } = getGlobalObjects();
    this.ee = ee;
    this.sink = sink;
  }
  /**
   * Get the latest events, newest first
   */
  log(channel, topic) {
    return this.sink.log(channel, topic);
  }
  /**
   * Get the latest event
   */
  peek(channel, topic) {
    return this.sink.peek(channel, topic);
  }
  publish(channel, topic, payload) {
    const event = new Event(channel, topic, payload);
    this.ee.emit(event.toKey(), event);
    this.sink.push(event);
    return event;
  }
  subscribe(channel, topic, listener) {
    this.ee.on(toKey(channel, topic), listener);
  }
  unsubscribe(channel, topic, listener) {
    this.ee.off(toKey(channel, topic), listener);
  }
};

// src/debugLogger.ts
var debugLog = (...args) => {
};

// src/performance.ts
var pageLoadedTimeInMs = Date.now();
var analysisActive = {
  xandrEvents: false,
  messageBusEvents: false
};
function getFormattedXandrTags() {
  const tags = window.apntag.requests.tags;
  return Object.values(tags).map((tag) => {
    const { targetId, sizes, keywords, allowedFormats, invCode, adResponse } = tag;
    const tagObj = {
      targetId,
      invCode,
      sizes,
      allowedFormats,
      keywords
    };
    if (typeof adResponse === "object") {
      const { tag_id, auction_id } = adResponse;
      tagObj.tag_id = tag_id;
      tagObj.auction_id = auction_id;
    }
    return tagObj;
  });
}
if (typeof window !== "undefined") {
  window.ADVT_EVENTS = window.ADVT_EVENTS || {
    performance: {
      xandrEvents: [],
      messageBusEvents: []
    },
    analysis: () => {
      analysisActive.xandrEvents = true;
      logTitle("Advertising Analysis Active", 22);
      try {
        if (window.apntag) {
          logTitle("Xandr Keywords");
          console.table(window.apntag.requests.keywords);
          logTitle("Xandr Tags");
          console.table(getFormattedXandrTags());
          console.log("Xandr tags raw: ", window.apntag.requests.tags);
        }
      } catch (e) {
        console.error(e);
      }
      logTitle("Advertising Events");
      console.table(window.ADVT_EVENTS.performance.xandrEvents);
    },
    mbAnalysis: () => {
      analysisActive.messageBusEvents = true;
      logTitle("Message Bus Events Analysis Active");
      console.table(window.ADVT_EVENTS.performance.messageBusEvents, [
        "channel",
        "topic",
        "event",
        "payload",
        "timeSincePageLoadInMs"
      ]);
    }
  };
}
function addToPerformanceArray(key) {
  return (entry) => {
    if ("performance" in window.ADVT_EVENTS) {
      window.ADVT_EVENTS.performance[key].push(entry);
      if (analysisActive[key]) {
        console.table(window.ADVT_EVENTS.performance[key]);
        console.log("Updated values ", { key, entry });
      }
    }
  };
}
function markXandrEvents(eventLabel, id) {
  if ("performance" in window.ADVT_EVENTS) {
    const entry = formatEntry(getLabelWithOptionalId(eventLabel, id));
    addToPerformanceArray("xandrEvents")(entry);
  }
}
function markMessageBusEvent({
  channel,
  topic,
  event,
  payload
}) {
  if ("performance" in window.ADVT_EVENTS) {
    const timeSincePageLoadInMs = Date.now() - pageLoadedTimeInMs;
    addToPerformanceArray("messageBusEvents")({
      channel,
      topic,
      event,
      timeSincePageLoadInMs,
      payload: JSON.stringify(payload)
    });
  }
}
function formatEntry(displayName) {
  const timeSincePageLoadInMs = Date.now() - pageLoadedTimeInMs;
  return {
    event: displayName,
    timeSincePageLoadInMs
  };
}
function logTitle(title, size = 16) {
  console.log(
    `%c${title}`,
    `font-weight: bold; font-size: ${size}px; color: #06bffc;`
  );
}
function getLabelWithOptionalId(label, id) {
  return `${label}${id ? " - " + id : ""}`;
}
var performance_default = {
  markMessageBusEvent,
  markXandrEvents
};

// src/messageBus.ts
var messageBus;
var callbackWrappers = /* @__PURE__ */ new Map();
function ensureMessageBusExists() {
  if (!messageBus) {
    messageBus = new MessageBus();
  }
}
function publish(channel, topic, payload) {
  debugLog("publish", channel, topic, payload);
  markMessageBusEvent({ event: "publish", channel, topic, payload });
  ensureMessageBusExists();
  messageBus.publish(channel, topic, payload);
}
function subscribe(channel, topic, callback) {
  debugLog("subscribe", channel, topic, callback);
  markMessageBusEvent({ channel, topic, event: "subscribe" });
  ensureMessageBusExists();
  const callbackWrapper = (event) => {
    markMessageBusEvent({
      channel,
      topic,
      event: "subscribe-callback",
      payload: event.payload
    });
    callback(event);
  };
  callbackWrappers.set(callback, callbackWrapper);
  messageBus.subscribe(channel, topic, callbackWrapper);
  return () => {
    unsubscribe(channel, topic, callback);
  };
}
function unsubscribe(channel, topic, callback) {
  debugLog("unsubscribe", channel, topic, callback);
  markMessageBusEvent({ event: "unsubscribe", channel, topic });
  ensureMessageBusExists();
  const callbackWrapper = callbackWrappers.get(callback);
  if (callbackWrapper) {
    messageBus.unsubscribe(channel, topic, callbackWrapper);
    callbackWrappers.delete(callback);
  } else {
    console.warn("Trying to unsubscribe a callback that wasn't subscribed.");
  }
}
function peek(channel, topic) {
  debugLog("peek", channel, topic);
  markMessageBusEvent({ event: "peek", channel, topic });
  ensureMessageBusExists();
  return messageBus.peek(channel, topic);
}
var messageBus_default = {
  publish,
  subscribe,
  peek
};

// src/events.ts
var events = {
  ADVERTISING: {
    channel: "advertising-podlet",
    CYCLE: {
      topic: "cycle-ad",
      sendPayload: ({ cycle }) => ({ cycle }),
      getPayload: (event) => event.payload
    }
  },
  COMPANION: {
    channel: "advertising-companion",
    PODLET_READY: {
      topic: "podlet-ready",
      sendPayload: (payload) => payload,
      getPayload: (event) => event.payload
    },
    PLACEMENT_READY: {
      topic: "placement-ready",
      sendPayload: (payload) => payload,
      getPayload: (event) => event.payload
    },
    AD_STYLES: {
      topic: "ad-styles",
      sendPayload: (payload) => payload,
      getPayload: (event) => event.payload
    },
    LAYOUT_TYPE_CHANGE: {
      topic: "layout-type-change",
      sendPayload: (payload) => payload,
      getPayload: (event) => event.payload
    }
  },
  SEARCH: {
    channel: "search",
    FILTER: {
      topic: "filters"
    }
  }
};
export {
  performance_default as advtPerformance,
  events,
  messageBus_default as messageBus
};
